import { Dispatch, SetStateAction, useCallback, useMemo, useState } from 'react'
import { useInterval } from 'usehooks-ts'

import { MAX_RETRIES, THIRTY_SECONDS } from '@/constants/polling'
import { getVod } from '@/services/blendvision'
import { Asset } from '@/types/asset'

export const usePollTrailerBlendVisionVodStatus = (
  assets: Asset[],
  setAssets: Dispatch<SetStateAction<Asset[]>>,
) => {
  const [retryCount, setRetryCount] = useState(0)

  const [stopInterval, unConvertedVodAssets] = useMemo(
    () => [
      assets.length <= 0 ||
        assets.every((asset) => asset.image?.url || asset.video?.isConverted) ||
        retryCount >= MAX_RETRIES,
      assets.filter((asset) => asset.video && asset.video.vodId && !asset.video.isConverted),
    ],
    [assets, retryCount],
  )

  const handleCheckVodStatus = useCallback(async () => {
    if (unConvertedVodAssets.length === 0) return

    setRetryCount((prev) => prev + 1)

    const promises = unConvertedVodAssets.map(async (asset) => {
      const vodResponse = await getVod(asset.video!.vodId)

      if (!('vod' in vodResponse)) {
        return
      }

      const vod = vodResponse.vod

      if (vod.status !== 'VOD_STATUS_SUCCEEDED') {
        return
      }

      const coverImage = vod.cover_image?.auto.url

      setAssets((prev) =>
        prev.map((a) =>
          a.video?.vodId === asset.video?.vodId
            ? {
                ...a,
                video: {
                  ...a.video!,
                  ...(coverImage && { coverImage }),
                  isConverted: true,
                },
              }
            : a,
        ),
      )
    })

    await Promise.all(promises)
  }, [unConvertedVodAssets, setAssets])

  useInterval(handleCheckVodStatus, stopInterval ? null : THIRTY_SECONDS)
}
